

exports.__esModule = true;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-ui-components/src/dropdown/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoDobCardInputDirective', {
    tag: 'xo-dob-card-input',
    template: _template2['default'],

    props: {
        user: {
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            function pad() {
                var length = arguments.length <= 0 || arguments[0] === undefined ? 2 : arguments[0];

                return function (num) {
                    return (new Array(length + 1).join('0') + num).substr(-length);
                };
            }

            var year = new Date().getFullYear();
            this.days = _squid.$util.map(_squid.$util.range(1, 32), pad());
            this.months = _squid.$util.map(_squid.$util.range(1, 13), pad());
            this.years = _squid.$util.map(_squid.$util.range(year - 100, year), pad(4)).reverse();
        }
    }
});


_squid.$Component;

_squid.$util;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-card/dob/directive.js
 ** module id = 273
 ** module chunks = 1
 **/